import { useEffect, useRef, useState } from "react";

const Quotes = () => {
  const text =
    "Introducing the beginning of our forever, a love story years in the making. As we prepare to say 'I do,' we are filled with gratitude for the people and moments that shaped us. This next chapter is a celebration of love, friendship, and family—and we are so glad you are part of it. Thank you for walking with us into this new adventure.";
  const [displayed, setDisplayed] = useState("");
  const [typing, setTyping] = useState(true);
  const [inView, setInView] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !inView) {
          setInView(true);
        }
      },
      {
        threshold: 0.3,
        rootMargin: "0px 0px -50px 0px",
      }
    );

    const currentRef = containerRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [inView]);

  useEffect(() => {
    if (!inView) return;

    setDisplayed("");
    setTyping(true);
    let i = 0;
    const interval = setInterval(() => {
      setDisplayed((prev) => prev + text[i]);
      i++;
      if (i >= text.length) {
        clearInterval(interval);
        setTyping(false);
      }
    }, 30);
    return () => clearInterval(interval);
  }, [inView]);

  return (
    <div
      className="bg-[rgba(42,46,50,1)] min-h-[70vh] flex flex-col justify-between items-center py-[4rem] lg:py-[6rem]"
      ref={containerRef}
    >
      <div
        className="flex justify-center h-5 w-full relative overflow-hidden"
        style={{
          backgroundImage: `url('/images/Frame 1.svg')`,
          backgroundSize: "cover",
          backgroundRepeat: "repeat-x",
          backgroundPosition: "top left",
        }}
      ></div>

      <div className="flex flex-col w-[88%] my-4 lg:my-10">
        <h3 className="font-brooklyn font-light uppercase text-2xl lg:text-[30px] tracking-wider leading-loose text-center text-[rgba(255,255,255,1)]">
          {displayed}
          {typing && <span className="animate-pulse">|</span>}
        </h3>
      </div>

      <div
        className="flex justify-center h-5 w-full relative overflow-hidden"
        style={{
          backgroundImage: `url('/images/Frame 1.svg')`,
          backgroundSize: "cover",
          backgroundRepeat: "repeat-x",
          backgroundPosition: "top left",
          transform: "scaleY(-1)",
        }}
      ></div>
    </div>
  );
};

export default Quotes;
